import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { Criterion } from "../models";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-criterion-evaluation",
  templateUrl: "./criterion-evaluation.component.html",
  // styleUrls: ['./criterion-evaluation.component.scss']
  encapsulation: ViewEncapsulation.None,
  providers: [],
})
export class CriterionEvaluationComponent implements OnDestroy {
  @Input() disabled: boolean;
  @Output() valueChange = new EventEmitter<Criterion>();

  criterion: Criterion;
  @Input() set model(value: Criterion) {
    this.criterion = value;
    this.formGroup = this.fb.group({
      totalEvaluation: [
        { value: this.criterion.totalEvaluation, disabled: true },
        [Validators.required],
      ],
      notes: [{ value: this.criterion.notes, disabled: this.disabled }],
      ...Object.assign(
        {},
        ...this.criterion.subCriterions.map((sub) => ({
          [sub.subCriterionKey]: [
            { value: sub.totalEvaluation || 0, disabled: this.disabled },
            [Validators.required, Validators.min(1)],
          ],
        }))
      ),
    });
    this.subscribeValueChange();
  }

  destroy$ = new Subject<void>();
  formGroup: FormGroup = null;

  constructor(private fb: FormBuilder) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private subscribeValueChange() {
    this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      const total: number = this.criterion.subCriterions
        .map((sub) => {
          const total = this.formGroup.get(sub.subCriterionKey).value;
          sub.totalEvaluation = total;
          return total;
        })
        .reduce((acc, currentValue) => acc + currentValue, 0);

      this.formGroup
        .get("totalEvaluation")
        .setValue(total, { emitEvent: false });
      this.criterion.totalEvaluation = total;
      this.criterion.notes = this.formGroup.get("notes").value;
      this.valueChange.emit(this.criterion);
    });
  }
}
